import React from 'react';
import clsx from 'clsx';

import styles from './EditShipService.module.scss';
import { ToastMessage } from '@components';
import toastMessageType from '@constant/ToastMessage';

import event from './event';
import { ORDER_STATUS, ORDER_STATUS_NAMES } from '@/config/constants';
import { Select } from '@/components';

function EditOnRight({
  user,
  selectedShipService,
  closeEditButton,
  fetchShipServices,
}) {
  const [shipService, setShipService] = React.useState({
    name: '',
    defaultShipStatusID: ORDER_STATUS.WAITING,
  });
  const [toastMessage, setToastMessage] = React.useState({
    isVisible: false,
    type: toastMessageType.SUCCESS,
    msg: {
      title: 'Lỗi',
      duration: 3000,
      desc: '',
    },
  });
  const handleInputChange = React.useCallback((e) => {
    const { name, value } = e.target;
    setShipService((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);
  const saveNewData = React.useCallback(
    (e) => {
      e.preventDefault();

      if (!shipService.name) {
        setToastMessage({
          isVisible: true,
          type: toastMessageType.ERROR,
          msg: {
            title: 'Lỗi',
            duration: 3000,
            desc: 'Tên không được để trống',
          },
        });
      } else {
        event.submitForm({
          user,
          shipService,
          setToastMessage,
          fetchShipServices,
          closeEditButton,
        });
      }
    },
    [shipService],
  );
  const isDisabled = React.useMemo(() => {
    const trimName = shipService.name.trim();
    const normalizedSelectedShipService = parseInt(
      selectedShipService.defaultBillStatus,
      10,
    );
    const normalizedShipService = parseInt(
      shipService.defaultBillStatus,
      10,
    );

    return (
      !trimName ||
      (trimName === selectedShipService.name &&
        normalizedShipService === normalizedSelectedShipService) ||
      trimName === ''
    );
  }, [
    shipService.name,
    selectedShipService.name,
    shipService.defaultBillStatus,
    selectedShipService.defaultBillStatus,
  ]);

  React.useLayoutEffect(() => {
    setShipService(selectedShipService);
  }, [selectedShipService]);

  React.useEffect(() => {
    return () => {};
  }, []);

  return (
    <form
      className={clsx(styles.form)}
      onSubmit={saveNewData}
      aftercontent={shipService.id ? 'Chỉnh sửa' : 'Tạo mới'}
    >
      <input
        className={clsx(styles.formInput)}
        value={shipService.name}
        name="name"
        onChange={handleInputChange}
        placeholder="Nhập tên đơn vị vận chuyển..."
      />

      <Select
        name="defaultBillStatus"
        select={{
          name: 'defaultBillStatus',
          items: Object.entries(ORDER_STATUS_NAMES).map(
            ([key, value]) => ({
              id: parseInt(key, 10),
              name: value,
            }),
          ),
        }}
        customSelectStyle={styles.formSelect}
        value={shipService.defaultBillStatus}
        onChange={handleInputChange}
      />

      <div className={clsx(styles.formAction)}>
        <button
          type="button"
          className={clsx(
            styles.formActionItem,
            styles.formActionItem_LowPriority,
          )}
          onClick={closeEditButton}
        >
          Hủy bỏ
        </button>

        <input
          className={clsx(styles.formActionItem, {
            [styles.disabled]: isDisabled,
          })}
          type="submit"
          value="Lưu"
          disabled={isDisabled}
        />
      </div>

      <ToastMessage open={toastMessage} setOpen={setToastMessage} />
    </form>
  );
}

export default EditOnRight;
